import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag, { bootstrap } from "vue-gtag"
import { MeasurementId } from "./utils/settings.js"

import './assets/css/main.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

const app = createApp(App)

app.use(router)
app.use(store)

// Register vue-gtag but DON'T load gtag.js yet. Nothing reaches Google
// until the visitor accepts (or has accepted on a prior visit).
app.use(VueGtag, {
  bootstrap: false,
  config: { id: MeasurementId }
}, router)

app.mount('#app')

// Returning visitor who already accepted -> consent default is already
// 'granted' from index.html, so load GA now.
if (/(?:^|;\s*)cookienotice=1(?:;|$)/.test(document.cookie)) {
  bootstrap()
}

